import { render, staticRenderFns } from "./TrAnalysisPdGraph.vue?vue&type=template&id=83ad0b48&scoped=true"
import script from "./TrAnalysisPdGraph.vue?vue&type=script&lang=ts"
export * from "./TrAnalysisPdGraph.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ad0b48",
  null
  
)

export default component.exports